import React from 'react';
import { useTranslation } from 'react-i18next';

import footerVuzLogo from '@shared/assets/lg_ag26/footer_vuz_logo.png';

import styles from '../styles/LgAg26Footer.module.css';

/**
 * Footer for the `lg_ag26` (UAE Marketing DCB) v5 variation.
 * Light-blue bar with copyright and the small VUZ wordmark.
 */
export const LgAg26Footer: React.FC = () => {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.content}>
        <p className={styles.copyright}>{t('lg_ag26_copyright', { year })}</p>
        <img className={styles.logo} src={footerVuzLogo} alt="VUZ" />
      </div>
    </footer>
  );
};

export default LgAg26Footer;
